import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation, Pagination]);

(function ($) {
  $(function () {
    var $scoreForm = $(".js-score-calculator");
    if ($scoreForm.length === 0) return;

    var $scoreResult = $(".js-score-calc-result");
    var $scoreNumber = $(".js-score-calc-result-number");
    var $scoreError = $(".js-score-calc-result-error");
    var $scoreMeterFill = $(".js-score-calc-meter-fill");
    var $scoreMeterTier = $(".js-score-calc-meter-tier");

    var scoreTiers = [];
    try {
      scoreTiers = JSON.parse($scoreResult.attr("data-tiers") || "[]");
    } catch (e) {
      scoreTiers = [];
    }
    scoreTiers.sort(function (a, b) {
      return a.min - b.min;
    });

    var scoreErrorText =
      $scoreResult.attr("data-error-text") ||
      "Not enough data to calculate the score.";

    var hasForm = window.ca && window.ca.calculatorForm !== undefined;
    var showResult = hasForm ? false : true;

    if (hasForm) {
      document.addEventListener("wpcf7mailsent", function(event) {
        if (parseInt(event.detail.contactFormId) !== parseInt(window.ca.calculatorForm)) return;

        showResult = true;
        $('body').removeClass("site-active-form-custom site-contact-form-open");
        scoreCalcRun();
      }, false);
    }

    function siteScrollIntoView($targetElement, offset) {
      offset = typeof offset !== "undefined" ? offset : 0;
      var headerHeight = $("header.site-header").height() || 0;
      var adminBarHeight = 0;
      var targetElementPosition = $targetElement.offset().top;
      if ($("body").hasClass("admin-bar")) {
        adminBarHeight = $("#wpadminbar").height() || 0;
      }
      var offsetPosition =
        targetElementPosition - headerHeight - adminBarHeight - offset;
      $("html, body").animate({ scrollTop: offsetPosition }, 400);
    }

    function scoreCalcReadInput($input) {
      var raw = $.trim($input.val());
      if (raw === "") return null;
      var num = parseFloat(raw);
      return isNaN(num) ? null : num;
    }

    function scoreCalcClampInput($input) {
      var raw = $.trim($input.val());
      if (raw === "") return;
      var num = parseFloat(raw);
      if (isNaN(num)) return;
      var min = parseFloat($input.attr("min"));
      var max = parseFloat($input.attr("max"));
      var clamped = num;
      if (!isNaN(max) && clamped > max) clamped = max;
      if (!isNaN(min) && clamped < min) clamped = min;
      if (clamped !== num) $input.val(clamped);
    }

    function scoreCalcGetUsedScore(subjectKey) {
      var examInput = $scoreForm.find(
        'input[data-subject="' + subjectKey + '"][data-kind="exam"]',
      );
      var annualInput = $scoreForm.find(
        'input[data-subject="' + subjectKey + '"][data-kind="annual"]',
      );

      var examVal = examInput.length ? scoreCalcReadInput(examInput) : null;
      if (examVal !== null) return examVal;

      var annualVal = annualInput.length
        ? scoreCalcReadInput(annualInput)
        : null;
      if (annualVal !== null) return annualVal;

      return null;
    }

    function scoreCalcCollectPool(poolAttr) {
      var keys = [];
      $scoreForm.find("input[" + poolAttr + '="1"]').each(function () {
        var key = $(this).attr("data-subject");
        if (key && keys.indexOf(key) === -1) {
          keys.push(key);
        }
      });
      return keys;
    }

    function scoreCalcPickMax(keys, excludeKeys) {
      excludeKeys = excludeKeys || [];
      var winner = null;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (excludeKeys.indexOf(key) !== -1) continue;
        var val = scoreCalcGetUsedScore(key);
        if (val === null) continue;
        if (winner === null || val > winner.value) {
          winner = { key: key, value: val };
        }
      }
      return winner;
    }

    function scoreCalcResolveTier(score) {
      var label = "";
      for (var i = 0; i < scoreTiers.length; i++) {
        if (score >= scoreTiers[i].min) {
          label = scoreTiers[i].label;
        }
      }
      return label;
    }

    function scoreCalcShowError() {
      $scoreError.text(scoreErrorText).removeAttr("hidden");
      $scoreResult
        .addClass("has-error")
        .removeClass("is-stale")
        .removeAttr("hidden");
      siteScrollIntoView($scoreResult, 30);
    }

    function scoreCalcShowResult(score) {
      var rounded = Math.round(score * 10) / 10;
      $scoreNumber.text(rounded.toFixed(1));

      var fillPercent = Math.max(0, Math.min(100, score * 10));
      $scoreMeterFill.css("width", fillPercent + "%");

      $scoreMeterTier.text(scoreCalcResolveTier(score));

      $scoreError.attr("hidden", "hidden").text("");
      $scoreResult.removeClass("has-error is-stale").removeAttr("hidden");

      siteScrollIntoView($scoreResult, 30);
    }

    function scoreCalcValidateRequired() {
      var ok = true;
      $scoreForm.find('input[data-required="1"]').each(function () {
        var $field = $(this).closest(".score-calc-field");
        if (scoreCalcReadInput($(this)) === null) {
          $field.addClass("has-error");
          ok = false;
        } else {
          $field.removeClass("has-error");
        }
      });
      return ok;
    }

    function scoreCalcCountOptionalExamsFilled() {
      var count = 0;
      $scoreForm
        .find('input[data-kind="exam"]')
        .each(function () {
          if ($(this).attr("data-subject") === "lithuanian") return;
          if (scoreCalcReadInput($(this)) !== null) count++;
        });
      return count;
    }

    function scoreCalcRun() {
      var requiredOk = scoreCalcValidateRequired();
      var optionalExamCount = scoreCalcCountOptionalExamsFilled();

      if (!requiredOk || optionalExamCount < 1) {
        scoreCalcShowError();
        return;
      }

      var mathScore = scoreCalcGetUsedScore("math");
      var lithuanianScore = scoreCalcGetUsedScore("lithuanian");

      if (lithuanianScore === null) {
        scoreCalcShowError();
        return;
      }

      if (mathScore === null) mathScore = 0;

      var secondPool = scoreCalcCollectPool("data-pool-second");
      var thirdPool = scoreCalcCollectPool("data-pool-third");

      var second = scoreCalcPickMax(secondPool, []);
      var third = scoreCalcPickMax(thirdPool, second ? [second.key] : []);

      var secondScore = second ? second.value : 0;
      var thirdScore = third ? third.value : 0;

      var score =
        (0.4 * mathScore +
          0.2 * secondScore +
          0.2 * thirdScore +
          0.2 * lithuanianScore) /
        10;

      if (showResult) {
        scoreCalcShowResult(score);
      } else {
        $('body').addClass("site-active-form-custom site-contact-form-open");
      }
    }

    $scoreForm.on("submit", function (e) {
      e.preventDefault();
      scoreCalcRun();
    });

    $scoreForm.on("input change", "input[type=number]", function () {
      var $input = $(this);
      scoreCalcClampInput($input);
      var $field = $input.closest(".score-calc-field");
      if (scoreCalcReadInput($input) !== null) {
        $field.removeClass("has-error");
      }
      if (!$scoreResult.is("[hidden]") && !$scoreResult.hasClass("has-error")) {
        $scoreResult.addClass("is-stale");
      }
    });

    document
      .querySelectorAll(".js-score-calc-courses-slider")
      .forEach(function (slider) {
        new Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 24,
          pagination: {
            el: slider.querySelector(".swiper-pagination"),
            type: "progressbar",
          },
          navigation: {
            nextEl: slider.querySelector(".js-nav-button-next"),
            prevEl: slider.querySelector(".js-nav-button-prev"),
          },
        });
      });
  });
})(jQuery);
